import { MapPin, Phone, Mail, Users, Globe, Truck } from 'lucide-react';

const ABOUT_IMG = "https://images.pexels.com/photos/22690552/pexels-photo-22690552.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_c0b7ab56-dc9b-46c6-8c6a-5be1ac8c634e/artifacts/1y3fjfg2_AMAZONIA%20-%20LOGO%402x.png";

export default function About() {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[300px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={ABOUT_IMG} alt="Kitchen" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <p className="text-xs uppercase tracking-[0.3em] text-[#F5C400] font-semibold mb-3">A propos</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">AMAZONIA.FOOD</h1>
          <p className="text-lg text-white/70 mt-3">Latin Food Delivery — Marque d'Elite Lead SRL</p>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#111] tracking-tight mb-6">
              Votre partenaire en produits latino-américains
            </h2>
            <div className="space-y-4 text-sm text-black/70 leading-relaxed">
              <p>
                Importation et distribution de produits alimentaires latino-américains dans tout le Benelux.
              </p>
              <p>
                Nous connectons les professionnels de la restauration, du commerce et de l'événementiel
                aux meilleures saveurs d'Amérique latine.
              </p>
              <p>
                Avec un catalogue de plus de 190 références soigneusement sélectionnées, nous proposons
                des produits authentiques allant des empanadas aux boissons tropicales, en passant par les
                épices, farines et snacks.
              </p>
            </div>
          </div>

          {/* Company Card */}
          <div className="border border-black/10 bg-white">
            <div className="p-6 border-b border-black/10 flex items-center gap-4">
              <img src={LOGO_URL} alt="Amazonia" className="h-14 w-auto" />
              <div>
                <h3 className="text-lg font-bold text-[#111]">AMAZONIA.FOOD</h3>
                <p className="text-xs text-black/50">Latin Food Delivery</p>
                <p className="text-xs text-black/40 mt-0.5">Marque d'Elite Lead SRL</p>
              </div>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#00A5FF] mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-1">Siège social</p>
                  <p className="text-sm text-[#111]">Rue Kwadeplas 2</p>
                  <p className="text-sm text-[#111]">1640 Rhode-Saint-Genèse, Belgique</p>
                  <p className="text-xs text-black/40 mt-1">TVA BE1011.252.120</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Users size={16} className="text-[#00A5FF] mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-1">Gérante</p>
                  <p className="text-sm text-[#111]">Désirée Malpica</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone size={16} className="text-[#00A5FF] mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-1">Téléphone</p>
                  <a href="tel:+32489102365" className="text-sm text-[#111] hover:text-[#00A5FF]">0489 10 23 65</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail size={16} className="text-[#00A5FF] mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-1">Email</p>
                  <a href="mailto:info@amazonia.food" className="text-sm text-[#111] hover:text-[#00A5FF]">info@amazonia.food</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Globe size={16} className="text-[#00A5FF] mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-1">Site web</p>
                  <a href="https://amazonia.food" className="text-sm text-[#111] hover:text-[#00A5FF]">amazonia.food</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-px bg-black/10 border border-black/10 mt-12">
          {[
            { value: '190+', label: 'Références', icon: Globe },
            { value: 'B2B', label: 'Service professionnel', icon: Users },
            { value: 'Benelux', label: 'Zone de livraison', icon: Truck },
          ].map((stat, i) => (
            <div key={i} className="bg-white p-8 text-center">
              <stat.icon size={24} className="text-[#00A5FF] mx-auto mb-3" />
              <p className="text-3xl font-extrabold text-[#111]">{stat.value}</p>
              <p className="text-xs text-black/50 mt-1 uppercase tracking-wider">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
